import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import CoverLayout from "layouts/authentication/components/CoverLayout";
import { registerUser } from "actions/AuthAction";
import { useSiteAssets } from "context/SiteAssetsContext";
import { SITE_ASSET_KEYS } from "utils/siteAssets";

function Cover() {
  const navigate = useNavigate();
  const { getAssetUrl } = useSiteAssets();
  const bgImage = getAssetUrl(SITE_ASSET_KEYS.BG_REGISTER);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    nik: "",
    nama: "",
    email: "",
    no_hp: "",
    username: "",
    password: "",
  });

  const handleChange = (field) => (e) => {
    setForm({ ...form, [field]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    registerUser(form, setLoading, navigate);
  };

  return (
    <CoverLayout image={bgImage}>
      <Card>
        <MDBox variant="gradient" bgColor="info" borderRadius="lg" mx={2} mt={2} p={3} mb={1} textAlign="center">
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Daftar Pemohon
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Buat akun untuk mengajukan layanan perizinan
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" onSubmit={handleSubmit}>
            {["nik", "nama", "email", "no_hp", "username", "password"].map((field) => (
              <MDBox mb={2} key={field}>
                <MDInput
                  type={field === "password" ? "password" : field === "email" ? "email" : "text"}
                  label={field.replace("_", " ").toUpperCase()}
                  variant="standard"
                  fullWidth
                  value={form[field]}
                  onChange={handleChange(field)}
                  InputLabelProps={{ shrink: true }}
                />
              </MDBox>
            ))}
            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" color="info" fullWidth type="submit" disabled={loading}>
                {loading ? "Memproses..." : "Daftar"}
              </MDButton>
            </MDBox>
            <MDBox mt={3} textAlign="center">
              <MDTypography variant="button" color="text">
                Sudah punya akun?{" "}
                <MDTypography component={Link} to="/authentication/sign-in/cover" variant="button" color="info" fontWeight="medium" textGradient>
                  Masuk
                </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </CoverLayout>
  );
}

export default Cover;
